<template>
  <div class="hello">
    <h1>{{msg}}</h1>
    <h2>flex-direction</h2>
    <div style="display: flex; flex-direction: row-reverse; background-color: aqua">
      <img src="../assets/logo.png" width="40px" height="40px">
      我跟图片在一条直线上
    </div>
    <div style="display: flex; flex-direction: row; background-color: beige">
      <img src="../assets/logo.png" width="40px" height="40px">
      我跟图片在一条直线上
    </div>
    <div style="display: flex; flex-direction: column; background-color: burlywood; text-align: left">
      <img src="../assets/logo.png" width="40px" height="40px">
      我跟图片在一条直线上
    </div>
    <div style="display: flex; flex-direction: column-reverse; background-color: blue; text-align: left">
      <img src="../assets/logo.png" width="40px" height="40px">
      我跟图片在一条直线上
    </div>
    <h2>flex-wrap</h2>
    <div style="width: 200px; display: flex; flex-wrap: nowrap; background-color: aqua">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
    </div>
    <div style="width: 200px; display: flex; flex-wrap: wrap; background-color: aqua">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
    </div>
    <div style="width: 200px; display: flex; flex-wrap: wrap-reverse; background-color: aqua">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
    </div>
    <div style="width: 200px; display: flex; flex-wrap: nowrap; background-color: aqua">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
    </div>

    <h2>justify-content</h2>
    <div style=" display: flex; background-color: aqua; justify-content: flex-start">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
    </div>
    <div style=" display: flex; background-color: aqua; justify-content: end">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
    </div>
    <div style=" display: flex; background-color: aqua; justify-content: center">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
    </div>
    <div style=" display: flex; background-color: aqua; justify-content: space-between; ">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
    </div>
    <div style=" display: flex; background-color: aqua; justify-content: space-around">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
    </div>
    <h2>align-items</h2>
    <div style="height: 200px; display: flex; background-color: aqua; justify-content: space-around; align-items: center">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
    </div>
    <div style="height: 200px; display: flex; background-color: bisque; justify-content: flex-end; align-items: stretch">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      你好啊
    </div>
    <div style="height: 200px; display: flex; background-color: greenyellow; justify-content: space-around; align-items: flex-start">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
    </div>
    <div style="height: 200px; display: flex; background-color: aqua; justify-content: space-around; align-items: flex-end">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
      <img src="../assets/logo.png" width="40px" height="40px">
    </div>

  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/FlexTest.vue